var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sl-alert-warning"},[_c('p',[_c('i',{staticClass:"fa fa-exclamation-triangle"}),_vm._v(" Seja bem vindo ao novo módulo de relatórios da Suporte Leilões")]),_vm._v(" Os relatórios antigos continuam sendo visualizados da forma antiga, estaremos atualizando-os aos poucos. Selecione o relatório no menu ao lado. ")])
}]

export { render, staticRenderFns }